import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { ProfileRead } from '../shared/profile-read.model';
import { TransactionsGridComponent } from '../../revenue/transactions-grid/transactions-grid.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { InvoiceAdvancedSearch } from '../../revenue/shared/invoice/invoice-advanced-search.model';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SerialSearchExpression } from 'src/app/shared/search-expression/serial-search-expression.model';
import { FieldValueOperatorEnum } from 'src/app/shared/search-expression/field-value-operator.enum';
import { ShareLinkDialogComponent } from 'src/app/shared/component/share-link-dialog/share-link-dialog.component';
import { ConfigService } from 'src/app/config/shared/config.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { BetaFeatureToggleEnum } from 'src/app/config/shared/constants/beta-feature-toggle.enum';
import { Title } from '@angular/platform-browser';
import { TranslationService } from 'src/app/shared';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';

@Component({
  selector: 'wl-profile-transactions',
  templateUrl: './profile-transactions.component.html',
  styleUrls: ['./profile-transactions.component.less'],
    standalone: false
})
export class ProfileTransactionsComponent implements OnInit, OnDestroy {
  @ViewChild(TransactionsGridComponent) private _transactionsGridComponent: TransactionsGridComponent;
  @ViewChild(ShareLinkDialogComponent) private _shareLinkDialog: ShareLinkDialogComponent;
  public invoiceSearchParams: InvoiceAdvancedSearch;
  public profile: ProfileRead;
  public profileId: number;
  public totalAmountDue: number;
  public showApplyPaymentDialog: boolean;
  hasMemberPortal = false;

  private _routeSubscription: Subscription;
  constructor(
    private _route: ActivatedRoute,
    private _profileService: ProfileService,
    private _configService: ConfigService,
    private _navigationService: NavigationService,
    private _translationService: TranslationService,
    private _configServiceService: ConfigServiceService,
    private _title: Title
  ) {}

  ngOnInit() {
    Promise.all([
      this._configService.hasBetaFeatureEnabled(BetaFeatureToggleEnum.MemberPortal),
      this._configServiceService.getWebComponentSettings('', true),
    ]).then((data) => {
      this.hasMemberPortal = data[0] || !!data[1]?.RedirectLegacyToNew;
    });

    this._routeSubscription = this._route.params.subscribe((params) => {
      this.profileId = parseInt(params.id, 10);
      this.loadProfile();
      this.searchInvoices();
    });
  }

  ngOnDestroy() {
    if (this._routeSubscription) {
      this._routeSubscription.unsubscribe();
    }
  }

  openShareLinkDialog() {
    const linkCallback: () => Promise<string> = async () => {
      if (this.hasMemberPortal) {
        return this._profileService.getProfileAccessGuid(this.profileId).then((guidDto) => {
          return `${this._navigationService.getNewOnlineBillPayLink()}?profileGuid=${guidDto.Guid}`;
        });
      } else {
        return this._navigationService.getLegacyOnlineBillPayLink(this.profileId);
      }
    };

    this._shareLinkDialog.open(linkCallback);
  }

  private loadProfile() {
    this._profileService.getProfile(this.profileId).then((profile) => {
      this.profile = profile;
      this._title.setTitle(profile.ReportName + ' ' + this._translationService.getInstant('common.profile.transactions'));
    });

    this._profileService.getProfileTotalAmountDue(this.profileId, true).then((data: number) => {
      this.totalAmountDue = data;
    });
  }

  private searchInvoices() {
    this.invoiceSearchParams = new InvoiceAdvancedSearch();
    this.invoiceSearchParams.PageSize = 10;
    const profileSearchExpression = new SerialSearchExpression();
    profileSearchExpression.Field = 'ProfileID';
    profileSearchExpression.FieldValueOperator = FieldValueOperatorEnum.Equals;
    profileSearchExpression.Value = this.profileId.toString();
    this.invoiceSearchParams.InvoiceInfoSearchExpressions.push(profileSearchExpression);
    if (this._transactionsGridComponent) {
      this._transactionsGridComponent.search();
    }
  }
}
